import { render, staticRenderFns } from "./TiskKoduWCasu.vue?vue&type=template&id=50e13cee&"
import script from "./TiskKoduWCasu.vue?vue&type=script&lang=ts&"
export * from "./TiskKoduWCasu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports